import { clsx } from "clsx";
import { useAppUI } from "~/components/layouts/minimal";

export enum DebugElement {
  INVISIBLE_BRIDGE = "INVISIBLE_BRIDGE",
  // Add more debug elements as needed
}

const debugColors = {
  [DebugElement.INVISIBLE_BRIDGE]: "bg-red-500/20", // red-500 with 20% opacity
} as const;

export const debugTheme = (element: DebugElement, className?: string): string => {
  const isDebug = useAppUI().state.isDebugMode;

  return clsx(className, isDebug && debugColors[element]);
};
